module.exports = __webpack_public_path__ + "static/media/jump-ropes.46db5d85.mp4";